import { SprievodnyDokumentDeleteApi } from 'evidencna-aplikacia-frontend-ts-axios';
import { evidenciaPrefixPath } from '../../configuration/apiConfigurationConstants';
import { ClientResponse } from '../../../model/ClientResponse';
import ApiConfiguration from '../../configuration/apiConfiguration';
import Uuid from '../../../model/Uuid';

const client = new SprievodnyDokumentDeleteApi(ApiConfiguration(evidenciaPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const deleteSprievodnyDokument = async (
  legMaterialUuid: Uuid,
  sprievodnyDokumentUuid: Uuid,
  headers?: object,
): Promise<ClientResponse<void>> => {
  const { status } = await client.deleteSprievodnyDokument(
    legMaterialUuid,
    sprievodnyDokumentUuid,
    headers,
  );
  return {
    responseCode: status,
  };
};
